/**
 * User Login Component
 * In this component we write all the Login Funcionalities
 * We are going to include Authetication
 * As In our Sysytem we have two types of Clients (Admin and Standard User)
 * We will have to Autheticate for both Clients
 *
 * ********************LOGIC****************
 * As we stored in our database a key => user role
 * So we are going to use that key (user_role) to verify user role ,
 * and we are going to redirect to User Dashboard if role is Admin else to Standard User Page
 */

import React from "react";
import LoginBanner from "../../../Assets/Images/../bgImage.png";
import {
  UserContainer,
  UserLoginContainer,
  LoginUpSide,
} from "./styled";

function Index() {
  return (
    <UserContainer maxWidth="xl">
      <UserLoginContainer maxWidth="sm">
        <LoginUpSide>
          <img src={LoginBanner} alt="Login Banner" />
        </LoginUpSide>
        {/* <LoginDownSide> */}
        {/* <LoginForm /> */}
        {/* </LoginDownSide> */}
      </UserLoginContainer>
    </UserContainer>
  );
}

export default Index;
